"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreBulletChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreBulletChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreBulletChart, _super);
    function CoreBulletChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreBulletChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "bullet" }, this.props));
    };
    return CoreBulletChart;
}(react_1.default.PureComponent));
exports.CoreBulletChart = CoreBulletChart;
//# sourceMappingURL=CoreBulletChart.js.map